import { BaseDto, FireBatchDto, MerchantDto, PaymentSourceDto } from '@up/data';

export class FireBatchTransferDto extends BaseDto {
  parentRow?: FireBatchDto;
  fireBatchId?: number;
  transferId?: string;
  merchantId?: number;
  merchant: MerchantDto;
  merchantName?: string;
  sourceId?: number;
  source?: PaymentSourceDto;
  sourceDescription?: string;
  additionalData: {
    cardFeePercentage?: number;
    totalGrossAmount?: number;
    totalCardFeeAmount?: number;
    totalProcessingFeeAmount?: number;
    totalServiceFeeAmount?: number;
    totalServiceChargeAmount?: number;
    totalDeliveryFeeAmount?: number;
    totalRefundProcessingFeeAmount?: number;
    totalNetAmount?: number;
    upCoFee?: number;
    transferFee?: number;
    totalTransferAmount?: number;
    totalPayments?: number;
    totalRefunds?: number;
    yourRef?: string;
    myRef?: string;
    ican?: string;
    iban?: string;
    accountName?: string;
    currency?: string;
    giftCard?: {
      physicalCards?: number;
      digitalCards?: number;
      inStoreCards?: number;
      fromDashboardCards?: number;
      subscription?: string;
      totalCards?: number;
      perCardPrice?: number;
      perCardsTotalFeeAmount?: number;
      perCardsVatPercentage?: number;
      perCardsVatAmount?: number;
    };
  };
}
